/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Форма оценки менеджера
   */
  app.ManagerGradeFormView = app.FormView.extend({
    el: '.mark-manager-block',
    grades: new app.Collection(),
    grade: false,
    
    events: {
      'click #form-submit': 'submit',
      'click .marks-list li:not(.active)': 'selectGrade'
    },
    
    selectGrade: function (e) {
      var grade = this.grades.get($(e.target).data('id'));
      if (grade) {
        this.applySelectedGrade(grade);
        this.save();
      }
    },
    
    beforeRun: function () {
      this.grades.reset(app.jsonGrades);
      this.model = new app.ManagerGrade();
      if (app.jsonLastGrade) {
        this.model.set(app.jsonLastGrade);
        var grade = this.grades.get(this.model.get('grade_id'));
        if (grade) {
          this.applySelectedGrade(grade);
          this.$('#form-comment').val(this.model.get('comment'));
        }
      }
    },
    
    applySelectedGrade: function (grade) {
      this.grade = grade;
      this.$('.description').html(grade.get('description'));
      this.$('#form-grade-id').val(grade.get('id'));
      this.$('.mark-pane').addClass('active');
      this.$('.marks-list li').removeClass('active');
      this.$('.marks-list li[data-id=' + grade.get('id') + ']').addClass('active');
      if (!grade.get('is_comment_enabled')) {
        this.$('form').hide();
      } else {
        this.$('form').show();
      }
      if (!grade.get('is_yandex_link_enabled')) {
        this.$('.mark-yandex').hide();
      } else {
        this.$('.mark-yandex').show();
      }
    },
    
    /**
     * Сохранение модели.
     */
    save: function () {
      var attributes = [];
      var that = this;
      this.$fields.each(function () {
        if (this.name == 'comment' && that.grade && !that.grade.get('is_comment_enabled')) {
          $(this).val('');
        }
        attributes[this.name] = $(this).val();
      });
      this.model.save(attributes);
      
      return false;
    },
    
    /**
     * Сохранение модели и переход в кабинет.
     */
    submit: function () {
      this.save();
      location.href = app.entryScriptName + '/cabinet';
      
      return false;
    }
  });
})(jQuery);

}.call(window));